"use client";

import * as React from "react";

import { cn } from "@/src/lib/utils/cn";

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    return <input ref={ref} className={cn("auth-input", className)} {...props} />;
  }
);

Input.displayName = "Input";
